import { Button, Stack } from "@mui/material";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { useUnsavedReportContext } from "../../contexts/UnsavedReportContext";

interface Props {
  text: string;
}

const ReportLoader = ({ text }: Props) => {
  const unsavedReport = useUnsavedReportContext();

  if (!unsavedReport) {
    return <InlineLoader text={text} />;
  }

  return (
    <Stack spacing={2} sx={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
      <InlineLoader text={text} sx={{ flexGrow: 0 }} />
      <Button variant="outlined" color="secondary" onClick={unsavedReport.onClose}>
        Close
      </Button>
    </Stack>
  );
};

export default ReportLoader;
